import {Map} from 'immutable';

export enum ToastTypes {
    SHOW_TOAST = 'SHOW_TOAST',
    DISMISS_TOAST = 'DISMISS_TOAST'
}

// @depreciated
export const TYPES = ToastTypes;

export enum TOAST_CONTENT_TYPE {
    DEFAULT = 'DEFAULT',
    POST_PURCHASE = 'POST_PURCHASE'
}

export interface PostPurchaseData {
    offer: {
        id?: string;
        namespace?: string;
    };
    productName: string;
    productSlug?: string;
}

export interface PostPurchaseDataMap extends Map<string, any> {
    toJS(): PostPurchaseData;
    get<K extends keyof PostPurchaseData>(key: K): PostPurchaseData[K];
}

export interface ToastContent {
    text?: string;
    avatar?: {
        avatar: string;
        displayName: string;
    };
    isError?: boolean;
    type?: TOAST_CONTENT_TYPE;
    postPurchaseData?: PostPurchaseData;
    messages?: any;
    icon?: any;
}

export interface ShowToastPayload extends ToastContent {
    id: number;
}

export interface ShowToastPayloadMap extends Map<string, any> {
    toJS(): ShowToastPayload;
    get<K extends keyof ShowToastPayload>(key: K): ShowToastPayload[K];
}

export interface DismissToastPayload {
    id: number;
}

export interface ToastAction {
    type: ToastTypes;
    payload?: ShowToastPayload | DismissToastPayload;
}

export default {
    // @depreciated
    TYPES,
    TOAST_CONTENT_TYPE,

    showToast: (content: ToastContent): ToastAction => ({
        type: TYPES.SHOW_TOAST,
        payload: {
            id: Date.now(),
            ...content
        }
    }),

    dismissToast: (id: number): ToastAction => ({
        type: TYPES.DISMISS_TOAST,
        payload: {id}
    })
};
